import { getField, updateField } from 'vuex-map-fields';

const getters = {
    getField,
};

const state = {
    selected_site_id: null,
    selected_site: {}
};

const mutations = {
    updateField,
};

const actions = {

};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};